import { render, staticRenderFns } from "./storeMessage.vue?vue&type=template&id=3dd4ff85&"
import script from "./storeMessage.vue?vue&type=script&lang=js&"
export * from "./storeMessage.vue?vue&type=script&lang=js&"
import style0 from "./storeMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports